export enum PageType {
  Category = 'category',
  Partner = 'partner',
  Search = 'search',
}

export type FilterNavType = 'sticky filter' | 'collapsed sidebar' | 'fixed sidebar';
